import { Portfolio } from '@unistocks/features/portfolios/portfolio';
import { PortfolioActions } from '@unistocks/features/portfolios/store/portfolio.slice';
import { usePortfoliosGetQuery } from '@unistocks/proxy/axios-client/PortfoliosQuery';
import { useAppDispatch } from '@unistocks/shared/hooks/redux-hooks';
import { t } from '@unistocks/shared/localization/index.ts';
import { HasId } from '@unistocks/types/has-id';
import { useFocusEffect, useLocalSearchParams, useNavigation } from 'expo-router';
import Head from 'expo-router/head';
import { useCallback } from 'react';

export default function PortfolioScreen() {
  const navigation = useNavigation();
  const dispatch = useAppDispatch();
  const { id } = useLocalSearchParams<HasId>();
  const { data: portfolio, isSuccess } = usePortfoliosGetQuery({ id });

  useFocusEffect(
    useCallback(() => {
      if (portfolio) {
        navigation.setOptions({ title: portfolio.name });
        dispatch(PortfolioActions.setSelectedPortfolioId(portfolio.id));
      }
    }, [dispatch, navigation, portfolio])
  );

  let title = t('::Portfolio');
  if (isSuccess) {
    title = `${portfolio.name} | ${title}`;
  }

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <Portfolio id={id} />
    </>
  );
}
